
import { Pipe, PipeTransform } from '@angular/core';
import { NotifiableContactEntity } from '@jms/model';

@Pipe({
    name: 'emailContacts',
    standalone: true
})
export class ActivityEmailContactsPipe implements PipeTransform {

    transform(
        value: NotifiableContactEntity[]
    ): string {

        if (!value) {
            return '';
        }

        const joined = value
            .map(contact => {
                if (!contact.name || contact.name === contact.email) {
                    return contact.email;
                }

                return `${contact.name} <${contact.email}>`
            })
            .join(', ');

        return joined;
    }
}